export interface TermsDocument {
    id: string;
    title: string;
    lastUpdated: string;
    content: string;
}
const termsData: TermsDocument[] = [
    {
        id: "terms-of-service",
        title: "서비스 이용약관",
        lastUpdated: "2025-03-25",
        content:
            `<section>
                <div>
                    <strong>제1조 (목적)</strong>
                    <p>본 이용약관은 ㈜데이터유니버스(이하"회사")에서 제공하는'휴대폰가족보호'(이하"서비스")서비스를 이용하는 자(이하"이용자")와 회사 간의 권리, 의무 및 책임사항 등 기본적인 사항의 규정을 목적으로 합니다.</p>
                </div>
                <div>
                    <strong>제2조 (용어의 정의)</strong>
                    <p>본 약관에서 사용되는 용어의 정의는 다음과 같습니다.</p>
                    <ul>
                        <li>1. "휴대폰"이란 와이파이 및 데이터로 인터넷 이용이 가능한 스마트폰 단말을 의미합니다.</li>
                        <li>2. "서비스"란 이용자의 휴대폰 상태를 통해 위급상황 및 신체활동 상태 등을 판단하여 보호자에게 해당 사실을 알리는 안심서비스를 말합니다.</li>
                        <li>3. "협약기관"이란 본 서비스를 이용자에게 무상으로 제공하기 위해 회사와 협약을 체결한 기관을 말합니다.</li>
                        <li>4. "이용자"란 협약기관을 통해 본 서비스에 10개월간 무상으로 가입한 고객으로서, 위급상황 발생 시 보호자로부터 보호조치 등을 받는 자를 말합니다.</li>
                        <li>5. "보호자"란 이용자가 지정한 이용자에 대한 보호의무를 이행하는 자로서, 이용자의 동의를 득하여 이용자의 상태, 위치 등의 정보를 제공받고 보호조치 등을 취하는 자를 말합니다.</li>
                        <li>6. "앱"이란 서비스 제공 및 이용을 위해 단말기에 설치되는'휴대폰가족보호'스마트폰 전용 애플리케이션을 말합니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제3조 (약관의 효력 및 변경)</strong>        
                    <ul>
                        <li>① 본 약관은 서비스에 이용을 신청한 이용자(이하“가입신청자”)가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로 등록함으로써 그 효력이 발생합니다</li>
                        <li>② 회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있으며, 회사가 약관을 변경할 경우에는 적용일자 및 변경사유를 명시하여 회사가 운영하는 사이트에서 적용일자7일 전에 고지합니다. 다만, 이용자에게 불리하게 약관을 변경하는 경우에는 30일 전에 고지합니다</li>
                        <li>③ 회사가 제2항에 따라 변경 약관을 고지하였음에도 이용자가 약관 변경 적용일까지 변경 약관에 대한 거부의사를 표시하지 않으면 약관의 변경에 동의한 것으로 간주합니다. 이용자가 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단할 수 있으며, 이 경우 협약기관을 통해 해지 절차를 안내받아야 합니다.</li>
                        <li>④ 본 서비스는 협약기관과의 협약에 따라 10개월간 무상으로 제공되며, 별도의 해지 신청 없이 자동 종료됩니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제4조 (이용 신청 및 이용 계약의 성립)</strong>
                    <ul>
                        <li>① 본 서비스 이용계약은 협약기관(이하 “대전광역시 유성구청”)을 통해 신청된 이용자(이하“가입신청자”)에 대해 회사가 이를 승낙함으로써 체결됩니다.</li>
                        <li>② 가입신청자가 본 약관에 동의하였을 경우 본 약관의 내용을 모두 인지하였으며 서비스와 관련하여 본 약관에 따라 회사에서 제공하는 모든 서비스에 동의한 것으로 봅니다.</li>
                        <li>③ 가입신청자가 본 약관의 내용(약관 변경 시 변경된 내용 포함)을 알지 못하여 발생하는 손해 및 피해에 대해서는 회사는 일체 책임을 지지 않습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제5조 (서비스의 내용)</strong>
                    <p>'휴대폰가족보호'는 이용자와 보호자를 연결하여 휴대폰 및 서비스 이용상태를 통해 위급상황에 대처하며, 이용자의 현재 위치와 활동량 체크, 건강/여행/운세 콘텐츠를 통해 지속적으로 서로의 안위를 확인할 수 있는 안심서비스입니다.</p>
                    <ul>
                        <li>1. 안부 확인 및 응급 인지: 단계별 안부 확인 안심콜(이용자의 응답 상태에 따라 단계별로 TTS알림, 강제영상통화 진행), 낙상 감지(긴급전화 연결, 보호자 통화 연결), 긴급호출(보호자에게 긴급상황 알림, 긴급전화 연결 및 플래시/사이렌 작동)</li>
                        <li>2. 안심존 이탈 알림: 안심존 설정, 이탈 확인 및 알림</li>
                        <li>3. 건강 관리: 걸음수로 활동량 체크, 목표에 따른 응원, 칭찬하기 기능</li>
                        <li>4. 상태 확인 및 알림: 이용자의 현재 위치와 거주지 날씨, 미세먼지 정보 등 확인, 이용자 상태에 따른 알림 발생과 안위 확인 기능 제공</li>
                        <li>5. 콘텐츠: 건강/여행/운세 등 다양한 콘텐츠 제공</li>
                    </ul>
                </div>
                <div>
                    <strong>제6조 (서비스 이용 및 제공)</strong>
                    <p>본 서비스는 협약기관(이하 "대전광역시 유성구청")과의 협약에 따라 이용자에게 무상으로 제공됩니다.</p>
                    <ul>
                        <li>① 서비스 이용 기간은 서비스 이용신청을 회사가 승낙한 날로부터 10개월이며, 별도의 해지 신청 없이 자동 종료됩니다.</li>
                        <li>② 본 서비스 이용자에게는 미아/치매노인찾기 비용 보상을 위한 기업비용보상보험이 적용됩니다. 본 보험은 협약기관을 통해 서비스에 10개월간 무상으로 가입한 이용자에게 적용되며, 이용기간이 종료된 경우 보험계약은 자동 철회됩니다.</li>
                        <li>③ 보험 가입 및 관련 사항은 본 약관 제14조를 통해 확인하시기 바랍니다.</li>
                        <li>④ 서비스는 연중무휴 1일 24시간 제공을 원칙으로 합니다. 단, 시스템 점검, 천재지변 등 불가항력적인 사유로 인해 서비스 제공이 일시 중단될 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제7조 (이용신청에 대한 승낙의 유보 및 서비스 이용의 제한)</strong>
                    <ul>
                        <li>① 제4조에 따라 가입신청자가 서비스 이용을 신청하면 회사는 원칙적으로 이를 승낙합니다. 단, 다음 각 호에 해당하는 신청에 대해서는 그 사유가 해소될 때까지 승낙을 유보하거나 거부할 수 있습니다.
                            <ul>
                                <li>1. 기술적인 문제로 인해 서비스를 제공할 수 없는 경우</li>
                                <li>2. 가입신청자의 단말기가 문자 수신(SMS/MMS), 앱PUSH 수신에 문제가 있는 경우 또는 기타 사유로 문자 전송(SMS/MMS), 앱PUSH 전송을 받을 수 없는 경우</li>
                                <li>3. 사용하는 단말기의 운영체제(OS), 기기정보 등을 루팅, 탈옥 등을 통해 임의로 변경한 경우</li>
                                <li>4. 단말기 특성 또는 OS 버전의 문제로 인해 정상적인 서비스 제공이 불가능한 경우</li>
                            </ul>
                        </li>
                        <li>② 회사는 정기점검 및 기타 기술상의 이유, 기타 운영상의 사유와 목적에 따라 회사가 정한 기간 동안 서비스를 일시 중지할 수 있으며, 기술상, 운영상의 사유와 목적에 따라 사전 공지 없이 서비스가 일시 중지될 수 있습니다.</li>
                        <li>③ 회사는 전시•사변•천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우 등 기타 부득이한 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제8조 (서비스의 해지)</strong>
                    <ul>
                        <li>① 본 서비스는 이용자가 서비스에 가입한 날로부터 10개월 후 자동으로 해지됩니다.</li>
                        <li>② 즉시 해지를 원할 경우, 거주지 동 또는 사업을 신청한 행정복지센터에 방문하여 해지 절차를 안내받을 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제9조 (정보의 제공)</strong>            
                    <ul>
                        <li>① 회사는 서비스 운영과 관련하여 이용자에게 다음과 같은 정보를 제공할 수 있습니다.
                            <ul>
                                <li>1. 서비스 이용 안내</li>
                                <li>2. 서비스 변경 사항</li>
                                <li>3. 서비스 중단 및 재개 안내</li>
                                <li>4. 기타 서비스 이용에 필요한 정보</li>
                            </ul>
                        </li>
                        <li>② 회사는 위 정보를 앱/웹에 게재하거나 문자메시지(SMS/MMS), Push message 등의 방법을 통해 제공할 수 있습니다.</li>
                    </ul>
                </div>      
                <div>
                    <strong>제10조 (데이터 수집 및 사용)</strong>        
                    <ul>
                        <li>① 회사는 서비스와 관련하여 이용자로부터 수집한 개인정보를 이용자의 사전 동의 없이 개인정보의 일부를 삭제하거나 일부 또는 전부를 대체하는 등의 방법으로 추가 정보가 없이는 특정 개인을 알아볼 수 없도록 처리한 정보를 개인정보보호법 제28조의2에서 정한 목적에 따라 사용할 수 있습니다.</li>
                        <li>② 회사는 이용자의 정보를 철저히 보안 유지하며, 서비스를 통해 생성되는 휴대폰 이용 데이터 및 이용자 정보 등을 이용자가 동의한 범위 및 법규에서 허용된 범위 이내에서 수집‧이용 및 보호자에게 제공하고 이외의 다른 목적으로 이용하지 않습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제11조 (회사의 의무)</strong>
                    <ul>
                        <li>① 회사는 본 약관에 정한 바에 따라 지속적, 안정적으로 서비스를 제공할 의무가 있습니다. 단, 전쟁 지진, 재난 등 천재 지변이나 불가피한 시스템의 고장 등 불가항력의 사유가 발생한 경우에는 본 서비스를 중단할 수 있습니다.</li>
                        <li>② 회사는 서비스 제공과 관련하여 취득한 이용자 정보를 본인의 사전 승낙 없이 제3자에게 누설 또는 배포하지 않습니다. 다만, 관계법령에 의한 수사상의 목적으로 관계기관으로부터 요구받은 경우나 국가기관의 요청이 있는 경우에는 그러하지 않습니다.</li>
                        <li>③ 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 이용자와의 계약 관련 절차 및 내용 등에 있어 편의를 제공하도록 노력합니다.</li>
                        <li>④ 회사는 이용자에게 안정적인 서비스 제공을 위하여 지속적으로 관련 시스템이나 절차, 기능 등의 예방 점검, 유지 보수 등을 이행하며, 회사 내부의 원인에 의해 서비스 장애가 발생하는 경우에는 부득이한 사유가 없는 한 곧바로 이를 수리 및 복구합니다.</li>
                        <li>⑤ 회사는 서비스와 관련한 이용자의 불만사항을 접수하면 신속히 처리해야 할 의무가 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제12조 (이용자의 의무)</strong>
                    <ul>
                        <li>① 이용자는 본인이 설정한 서비스 설정에 책임을 지며, 이용자 부주의로 인해 발생하는 모든 결과에 대한 책임은 이용자에게 있습니다</li>
                        <li>② 이용자는 서비스를 이용할 때 다음 각 호의 행위를 하여서는 아니 됩니다.<br/>
                            <ul>
                                <li>1. 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위</li>
                                <li>2. 타인의 명예를 손상시키거나 불이익을 주는 행위, 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위</li>
                                <li>3. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 유포하는 행위</li>
                                <li>4. 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보를 전송하는 행위</li>
                                <li>5. 관련 법령에 의하여 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위</li>
                                <li>6. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위</li>
                                <li>7. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 e-mail로 발송하는 행위</li>
                                <li>8. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위</li>
                                <li>9. 스토킹(stalking) 등 다른 이용자를 괴롭히는 행위 등 기타 불법적이거나 부당한 행위</li>
                                <li>10. 기타 관계 법령에 위배되거나 공서양속에 반하는 행위</li>
                            </ul>
                        </li>
                        <li>③ 이용자는 관계 법령, 본 약관의 규정, 이용안내 및 서비스 상에 공지한 주의사항, 회사가 통지하는 사항 등을 따라야 하며, 기타 회사의 업무에 방해되는 행위를 해서는 안됩니다.</li>
                     </ul>
                </div>
                <div>
                    <strong>제13조 (이용자의 개인정보 보호)</strong>
                    <ul>
                        <li>① 회사는 관련 법령이 정하는 바에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위하여 노력합니다.</li>
                        <li>② 이용자의 개인정보 보호와 관련한 사항은 관계 법령과 회사가 정하는 개인정보처리방침을 따릅니다. 서비스 개인정보처리방침은 회사와 이용자 간 이용계약의 일부를 구성합니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제14조 (미아/치매노인찾기 비용 보상-기업비용보상보험)</strong>
                    <ul>
                        <li>① 회사가 보험계약을 체결하며, 보험 계약과 관련된 모든 권리 의무는 회사가 행사합니다. 보험료는 전액 회사가 부담하며, 보험금 지급 사유 발생 시 담보 내용인 미아찾기/치매노인찾기 각각 담보당 서비스 이용자 1인 1사고당 보험한도액은 200만원입니다. 보험금 지급 시 각 담보당 자기부담금(10만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.</li>
                        <li>② 미아찾기 비용: 보험기간 중 피보험자 고객 자녀(만 13세 이하)가 실종된 7일 내 관할 경찰서에 미아등록 후 가정으로 복귀하기까지 발생되는 비용</li>
                        <li>③ 치매노인찾기 비용: 보험기간 중 피보험자 본인(만 65세 이상 치매환자) 또는 피보험자 고객의 치매환자 부모(만 65세 이상)가 실종되어 관할 경찰서에 7일 내 실종 신고 이후 복귀하기까지 발생되는 비용</li>
                        <li>④ 본 보험은 협약기관을 통해 서비스에 10개월간 무상으로 가입한 이용자에게 적용되며, 이용기간이 종료된 경우 보험계약은 자동 철회됩니다.</li>
                        <li>⑤ 미아/치매노인찾기 비용 보상을 위한 기업비용보상보험은 이용자에게 무상으로 제공되는 보험이며, 보험한도액 및 자기부담금은 사고율에 따라 증감이 될 수 있고 단체보험계약이 철회될 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제15조 (손해배상)</strong>
                    <ul>
                        <li>① 회사와 이용자는 일방 당사자의 귀책사유로 인하여 상대방에게 발생한 손해에 대하여 배상해야 합니다.</li>
                        <li>② 회사는 본 서비스 이용자의 고의 또는 과실로 발생한 손해에 대해서 어떠한 책임도 지지 않습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제16조 (면책사항)</strong>
                    <ul>
                        <li>① 회사는 천재지변 또는 이에 준하는 불가항력으로 말미암아 서비스를 제공할 수 없을 때에는 서비스 제공에 대한 책임이 면제됩니다.</li>
                        <li>② 회사는 전기통신서비스 특성상 불가피한 사유로 서비스를 제공할 수 없거나 관련 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 일시적으로 서비스 제공을 중단할 수 있으며, 일시적 서비스 제공 중단에 회사의 귀책사유가 없는 경우 이에 대하여 책임을 지지 않습니다.</li>
                        <li>③ 회사는 이용자의 고의, 과실 또는 서비스 이용방법에 대한 미숙지 등의 귀책 사유로 서비스 이용의 장애, 회원정보나 자료 소실 또는 손해가 발생한 것에 책임을 지지 않습니다.</li>
                        <li>④ 회사는 이용자가 자료의 저장, 공유를 함으로써 발생하는 법적인 문제에 책임을 지지 않습니다.</li>
                        <li>⑤ 회사는 이용자 상호 간 또는 이용자와 제3자 상호간에 서비스를 매개로 발생한 분쟁에 개입할 의무가 없으며 이 때문에 발생한 손해를 배상할 책임도 없습니다.</li>
                        <li>⑥ 이용자가 자신의 개인정보를 타인에게 유출 또는 제공하거나 무단으로 사용 당하는 등 그 관리를 소홀히 했을 때 발생하는 피해에 대해 회사는 일절 책임을 지지 않습니다.</li>
                        <li>⑦ 회사는 이용자의 휴대폰 단말 오류, 제3자 제공 프로그램으로 인한 서비스 종료 및 오류 등 회사가 제공하는 서비스 외 외부환경에 따라 제공 기능이 정상적으로 동작하지 않아 발생한 손해에 책임을 지지 않습니다.</li>
                        <li>⑧ 이용자의 자발적인 이용 계약 해지로 인해 서비스 이용이 정지되어 이용자에게 손해가 발생하였을 때 회사는 이에 책임을 지지 않습니다.</li>
                        <li>⑨ 회사가 공식적으로 제공한 경로가 아닌, 비공식적 경로를 통해 서비스 앱을 다운로드/설치한 이용자에게 발생한 손해에 대하여 회사는 책임을 지지 않습니다.</li>
                        <li>⑩ 공식적 경로를 통하지 않고 비정상적으로 접근한 웹페이지 또는 설치된 타 앱 등에 의한 손해는 회사에서 책임을 지지 않습니다.</li>
                        <li>⑪ 회사에서 제공하는 서비스 기능 중 하나로 이용자가 등록한 보호자가 이용자의 상태를 확인할 수 있도록 정보를 전달하고 있습니다. 서비스의 범위는 사전에 설정한 상태에 관한 정보를 전달하는 것이며, 해당 정보를 통한 이용자의 위급상황 발생에 관한 대응은 보호자가 그 책임을 부담합니다.</li>
                        <li>⑫ 회사는 서비스를 통하여 수집 및 생성되는 이용자의 모든 정보에 대해 등록된 보호자가 무단 배포하는 것을 원칙적으로 금지합니다. 이를 위반할 때에는 관련 법령에 따라 형사처벌을 받을 수 있으며, 발생되는 문제에 대한 모든 책임은 서비스 이용자 및 이용자가 등록한 보호자에게 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제17조 (약관 외 준칙)</strong>
                    <p>이 약관에 명시되지 아니한 사항에 대해서는 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 통신비밀보호법 등 관계 법령과 회사가 정한 본 서비스의 세부이용지침 등의 규정을 따릅니다.</p>
                </div>
                <div>
                    <strong>제18조 (관할법원)</strong>
                    <p>서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생하면 회사와 이용자는 분쟁의 해결을 위해 성실히 협의합니다. 제1항의 협의에서도 분쟁이 해결되지 않으면 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수 있습니다.</p>
                </div>
                <div>
                    <strong>부칙</strong>
                    <p>(시행일) 본 약관은 2025년 3월 25일부터 시행됩니다.</p>
                </div>
</section>`
    },
    {
        id: "privacy-policy",
        title: "개인정보처리방침",
        lastUpdated: "2025-03-25",
        content:
            `<section>
                <div>
                    <p>주식회사 데이터유니버스(이하"회사")는 이용자의 개인정보를 중요시하며, 『개인정보보호법』을 준수하며, 관련 법령에 의거한 개인정보 처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>
                    <p>회사는 개인정보 처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보 보호를 위해 어떠한 조치가 취해지고 있는 지 알려드립니다.</p>
                    <p>회사는 개인정보 처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p>
                    <p>본 개인정보 처리방침은 회사가 제공하는 휴대폰가족보호 서비스 이용에 적용되며 다음과 같은 내용을 담고 있습니다.</p>        
                    <ul>
                        <li>&middot;개인정보의 수집 및 이용 목적</li>
                        <li>&middot;개인정보의 처리 및 보유기간</li>
                        <li>&middot;개인정보의 제3자 제공</li>
                        <li>&middot;개인정보의 취급 위탁</li>
                        <li>&middot;권리·의무 및 행사방법</li>
                        <li>&middot;개인정보의 파기</li>
                        <li>&middot;개인정보의 안전성 확보조치</li>
                        <li>&middot;개인위치정보의 처리</li>
                        <li>&middot;개인정보 보호책임자</li>
                        <li>&middot;권익침해 구제방법</li>
                        <li>&middot;고지의무</li>
                    </ul>
                </div>
                <div>
                    <strong>제1조 개인정보의 수집 및 이용 목적</strong>
                    <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 『개인정보 보호법』 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                    <p>가. 개인정보 수집 항목(필수)</p>
                    <p>[서비스 가입]</p>
                    <ul>
                        <li>- 휴대폰 번호</li>
                    </ul>        
                    <p>[서비스 이용]</p>
                    <ul>
                        <li>- 서비스 접속 일시, 가입경로, 서비스 이용기록, SMS/MMS & Push 전송 기록</li>
                        <li>- 휴대폰 위치 정보(개인위치정보는 이용자가 등록한 보호자 요청 시에만 조회하며 회사에서 보유하지 않음)</li>   
                        <li>- 기타 카메라, 오디오 권한 요청은 영상통화 기능에만 사용되며 별도로 서버에 저장하지 않습니다.</li>
                    </ul>        
                    <p>[홈페이지 고객 문의]</p>
                    <ul>
                        <li>- 이름, 휴대폰 가입통신사, 휴대폰 번호, 이메일, 문의내용</li>
                    </ul>
                    <p>나. 개인정보 수집 방법</p>
                    <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
                    <ul>
                        <li>- 유성구청 관할 동 행정복지센터를 통한 서비스 이용 신청</li>
                        <li>- PC 및 휴대폰 어플리케이션, 홈페이지 상담 게시판, 전화, 이메일</li>
                    </ul>
                    <p>다. 이용 목적</p>
                    <p>회사는 다음과 같은 목적으로 개인정보를 이용합니다.</p>
                    <ul>
                        <li>- 휴대폰가족보호(이하"서비스")의 제공, 유지, 관리, 서비스 분석을 위한 자료 활용, 분쟁 해결, 민원 처리, 법령상 의무이행, 회사의 개인정보 처리업무</li>
                        <li>- 위치정보 : 위급상황 발생 및 예방을 위한 위치 공유</li>
                        <li>- 서비스 해지 시 개인정보 수집, 이용이 철회됩니다.</li>
                    </ul>
                </div>                    
                <div>
                    <strong>제2조 개인정보의 보유 및 이용기간</strong>
                    <p>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
                    <ul>
                        <li>가. 본 서비스 가입일부터 해지 시까지</li>
                        <li>나. 개인위치정보는 이용자가 지정한 보호자의 요청 시에만 조회하며 회사에서 보유하지 않습니다.</li>
                        <li>다. 서비스 이용 목적을 달성한 경우 개인정보를 지체 없이 파기합니다. 단, 상법, 국세기본법, 소비자보호에 관한 법률 등 관계 법령에 따라 보존할 필요가 있는 경우 회사는 관계법령에서 정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 다음과 같습니다.</li>
                    </ul>
                    <table >
                        <tr>
                            <th>보존항목/내용</th>
                            <th>보존기간</th>
                            <th>보존근거/사유</th>
                        </tr>
                        <tr>
                            <td>거래에 관한 장부 및 증빙서류</td>
                            <td>5년</td>
                            <td>국세기본법, 법인세법, 부가가치세법 등</td>
                        </tr>
                        <tr>
                            <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                            <td>5년</td>
                            <td>전자상거래 등에서의 소비자 보호에 관한 법률</td>
                        </tr>
                        <tr>
                            <td>본인확인에 관한 기록</td>
                            <td>6개월</td>
                            <td>정보통신 이용촉진 및 정보보호 등에 관한 법률</td>
                        </tr>
                        <tr>
                            <td>계약 또는 청약철회 등에 관한 기록</td>
                            <td>5년</td>
                            <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                        </tr>
                        <tr>
                            <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                            <td>3년</td>
                            <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                        </tr>
                    </table>
                    <p>※그 외, 법률에 정해진 개인정보 보유기간이 있을 경우 그에 따름</p>
                </div>
                <div>
                    <strong>제3조 개인정보의 제3자 제공</strong>
                    <p>회사는 정보주체의 개인정보를 제1조(개인정보의 수집 및 이용 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 『개인정보 보호법』 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
                    <p>회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
                    <table>
                        <tr>
                            <th>제공받는 자</th>
                            <th>제공목적</th>
                            <th>제공항목</th>
                            <th>보유기간</th>
                        </tr>
                        <tr>
                            <td>이용자가 지정한 보호자</td>
                            <td>보호하기 기능 제공(위급 상황 발생 및 예방을 위한 서비스 이용 기록 및 위치정보 공유)</td>
                            <td>이용자정보(휴대폰번호, 프로필 사진 및 닉네임), 서비스 이용 기록, 위치정보</td>
                            <td>이용자정보: 그룹 나가기 또는 서비스 해지 시 파기<br>서비스 이용기록: 서비스 해지 또는 앱 삭제 시 파기<br>위치정보: 보호자 요청 시에만 조회하며 보유하지 않음</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <strong>제4조 개인정보의 취급 위탁</strong>
                    <p>회사는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 회사의 개인정보 위탁업체 및 위탁 업무는 아래와 같습니다.</p><br/>   
                    <table  style="width: 100%;">
                    <thead>가. 회사가 개인정보 처리 업무를 위탁하는 경우</thead>
                        <tr>
                            <th style="width: 20%;">제공받는 자</th>
                            <th style="width: 35%;">제공목적</th>
                            <th style="width: 20%;">제공항목</th>
                            <th style="width: 25%;">보유기간</th>
                        </tr>
                        <tr>
                            <td>㈜씨에스비즈케어</td>
                            <td>서비스 운영, 이용자 관리, 회원제 서비스 이용에 따른 본인확인, 고객상담, 불만 처리 등 고객 지원 업무</td>
                            <td>휴대폰 번호, 서비스 가입/해지 정보</td>
                            <td>서비스 해지 또는 위탁 계약 종료 시까지</td>
                        </tr>
                    </table>
                    <br/>
                    <table>
                    <thead>나. 회사가 개인정보 처리 업무를 위탁받는 경우</thead>
                        <tr>
                            <th style="width: 20%;">제공받는 자</th>
                            <th style="width: 35%;">제공목적</th>
                            <th style="width: 20%;">제공항목</th>
                            <th style="width: 25%;">보유기간</th>
                        </tr>
                        <tr>
                            <td>대전광역시 유성구청</td>
                            <td>
                                - 서비스의 제공, 유지, 관리<br/>
                                - 서비스 분석을 위한 자료 활용<br/>
                                - 분쟁해결, 민원처리, 법령상 의무이행<br/>
                                - 사업비 지급 관련 자료 제공<br/>
                                - 위급상황 발생 및 예방을 위한 위치 공유
                            </td>
                            <td>휴대폰 번호</td>
                            <td>서비스 해지 또는 위탁 계약 종료 시까지</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <strong>제5조 정보주체의 권리·의무 및 행사방법</strong>
                    <p>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                    <ul>
                        <li>가. 개인정보 열람요구</li>
                        <li>나. 오류 등이 있을 경우 정정 요구</li>
                        <li>다. 삭제 요구</li>
                        <li>라. 처리정지 요구</li>                    
                    </ul>
                    <p>제1항에 따른 권리 행사는 회사에 대해 『개인정보 보호법 시행규칙』 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
                    <p>정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
                    <p>제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 『개인정보 보호법 시행규칙』 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
                </div>
                <div>
                    <strong>제6조 개인정보의 파기</strong>
                    <p>회사는 수집한 개인정보의 보유기간 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
                    <p>정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>        
                    <p>개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>       
                    <p>가. 파기 절차</p>
                    <p>보존기간이 경과하거나 목적이 달성된 개인정보는 회사의 『개인정보 보호규칙』에 따라 개인정보 보호책임자의 승인을 받아 엄격한 통제절차에 의거 파기를 실시하고 있습니다.</p>        
                    <p>나. 파기 방법</p>
                    <p>회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</p>
                </div>
                <div>
                    <strong>제7조 개인정보의 안전성 확보조치</strong>
                    <p>회사는 『개인정보보호법』 제29조에 따라 다음과 같이 개인정보 안전성 확보에 관한 기술적·관리적·물리적 조치를 취하고 있습니다.</p>        
                    <p>가. 내부관리계획의 수립·시행</p>
                    <p>회사는 『개인정보 보호규칙』 및 개인정보보호 종합 추진계획을 통하여 다음 사항이 포함된 내부관리계획을 수립·시행하고 있습니다.</p>
                    <ul>
                        <li>1. 개인정보 보호책임자의 지정에 관한 사항</li>
                        <li>2. 개인정보 보호책임자 및 개인정보취급자의 역할 및 책임에 관한 사항</li>
                        <li>3. 개인정보의 안전성 확보에 필요한 조치에 관한 사항</li>
                        <li>4. 개인정보취급자에 대한 교육에 관한 사항</li>
                        <li>5. 그 밖에 개인정보 보호를 위하여 필요한 사항</li>
                    </ul>        
                    <p>나. 접근권한의 관리</p>
                    <ul>
                        <li>개인정보처리시스템에 대한 접근권한을 업무 수행에 필요한 최소한의 범위로 업무 담당자에 따라 차등 부여하고 있습니다.</li>
                        <li>전보 또는 퇴직 등 인사이동이 발생하여 개인정보취급자가 변경되었을 경우 지체 없이 개인정보처리시스템의 접근권한을 변경 또는 말소하고 있으며, 권한 부여, 변경 또는 말소에 대한 내역을 기록하고, 그 기록을 일정 기간 보관하고 있습니다.</li>
                        <li>개인정보처리시스템에 대한 접근권한을 업무 수행에 필요한 최소한의 범위로 업무 담당자에 따라 차등 부여하고 있습니다.</li>
                    </ul>        
                    <p>다. 개인정보암호화</p>
                    <p>개인정보는 암호화 등을 통해 안전하게 저장·관리되고 있습니다. 또한 개인정보 처리 시 중요 데이터를 DRM으로 관리하거나 파일 잠금 기능을 사용하는 등 별도 보안기능을 사용하고 있습니다.</p>        
                    <p>라. 접속기록의 보관 및 위·변조 방지</p>
                    <p>개인정보취급자가 개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관하고 있으며, 접속기록이 위·변조 및 도난, 분실되지 않도록 해당 접속기록을 안전하게 보관하고 있습니다.</p>        
                    <p>마. 보안프로그램 설치 및 운영</p>
                    <p>악성 프로그램 등을 방지 치료할 수 있는 백신 소프트웨어 등의 보안프로그램을 설치·운영</p>            
                    <p>바. 물리적 접근 방지</p>   
                    <p>전산실, 자료보관실 등 개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 있으며, 이에 대한 출입통제를 수립·운영하고 있습니다.</p>
                </div>
                <div>
                    <strong>제8조 개인위치정보의 처리</strong>
                    <p>회사는 위치정보의 보호 및 이용 등에 관한 법률(이하 '위치정보법')에 따라 아래와 같이 개인위치정보를 처리합니다.</p>           
                    <p>가. 개인위치정보의 처리목적 및 보유기간</p>
                    <p>회사는 위급상황 발생 및 예방을 위한 위치정보 공유를 목적으로 서비스 이용자가 지정한 보호자의 요청 시에만 개인위치정보를 조회하며 회사에서 보유하지 않습니다.</p>        
                    <p>나. 개인위치정보 수집이용제공사실 확인자료의 보유근거 및 보유기간</p>
                    <p>회사는 타사업자 또는 이용자와의 요금정산 및 민원처리를 위해 위치정보 이용제공 사실 확인자료를 자동 기록보존하며, 해당 자료는 6개월간 보관합니다.</p>        
                    <p>다. 개인위치정보의 파기 절차 및 방법</p>
                    <p>회사는 개인위치정보의 처리목적이 달성된 경우, 개인위치정보를 복구 및 재생이 불가능한 기술적인 방법으로 안전하게 파기하고 있습니다.</p>                    
                    <p>라. 개인위치정보의 제3자 제공 및 통보에 관한 사항</p>                    
                    <p>회사는 개인위치정보를 이용자가 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 이용자에게 제공받는 자, 제공일시 및 제공 목적을 즉시 통보합니다. 단, 아래 각호의 1에 해당하는 경우에는 이용자가 미리 특정하여 지정한 통신 단말장치 또는 전자우편주소로 통보합니다. 단 서비스 내'보호자'로 지정한 경우 서비스 이용 시 연결상태를 표시하여 정보 제공 여부를 통보합니다.</p>
                    <ul>
                        <li>1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                        <li>2. 이용자가 온라인 게시 등의 방법으로 통보할 것을 미리 요청한 경우</li>
                    </ul>
                    <p>마. 8세 이하의 등의 보호의무자 권리의무 및 그 행사방법</p>
                    <p>① 회사는 아래의 경우에 해당하는 자(이하 "8세 이하의 아동" 등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.</p>
                    <ul>
                        <li>1. 8세 이하의 아동</li>
                        <li>2. 금치산자</li>
                        <li>3. 장애인복지법 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용 촉진 및 직업재활법 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제29조의 규정에 의하여 장애인등록을 한 자에 한한다)</li>
                    </ul>
                    <p>8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.</p>
                    <p>보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.</p>
                    <p>바. 위치정보 관리책임자의 정보</p>
                    <p>위치정보 관리책임자는 개인정보 보호책임자가 겸직하고 있습니다.</p>
                </div>
                <div>
                    <strong>제9조 개인정보 보호책임자</strong>
                    <p>회사는 이용자의 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                    <p>정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>
                    <table>
                        <tr>
                            <th>개인정보 보호 책임자 및 담당자</th>
                        </tr>
                        <tr>
                            <td>가. 개인정보 담당부서: 기술개발본부<br/>나. 개인정보 책임자 및 담당자: 김정태 상무<br/>다. 전화번호: 1855-3631<br/>라. 메일: privacy@datau.co.kr</td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <th>서비스 고충처리 상담</th>
                        </tr>
                        <tr>
                            <td>전화번호: 1855-3631</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <strong>제10조 권익침해 구제방법</strong>
                    <table>
                        <tr>
                            <th>센터</th>
                            <th>전화번호</th>
                            <th>홈페이지</th>
                        </tr>
                        <tr>
                            <td>개인정보 침해신고센터/분쟁조정위원회</td>
                            <td>(국번없이) 118</td>
                            <td>http://privacy.kisa.or.kr</td>
                        </tr>
                        <tr>
                            <td>대검찰청 사이버범죄수사단</td>
                            <td>02)3480-3571</td>
                            <td>http://cybercid.spo.go.kr</td>
                        </tr>
                        <tr>    
                            <td>경찰청 사이버안전국</td>
                            <td>(국번없이) 182</td>
                            <td>http://cyberbureau.police.go.kr</td>
                        </tr>
                    </table>
                    <p>정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등의 문의하실 수 있습니다. 아래 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.</p>
                </div>
                <div>
                    <strong>제 11조 고지의무</strong>
                    <p>현 개인정보처리방침은 2025년 03월 25일에 제정되었으며 정보의 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 경우에는 개정 최소 7일 전부터 홈페이지를 통해 고지할 것입니다.</p>
                </div>
            </section>`
    },
    {
        id: "location-service-policy",
        title: "위치기반서비스 이용약관",
        lastUpdated: "2025-03-25",
        content:
            `<section>
                <div>
                    <strong>제1조(목적)</strong>
                    <p>본 약관은 데이터유니버스(이하 “회사”)가 제공하는 위치기반서비스에 대해 회사와 위치기반서비스를 이용하는 개인위치정보주체(이하 “이용자”)간의 권리·의무 및 책임사항, 기타 필요한 사항 규정을 목적으로 합니다.</p>
                </div>
                <div>
                    <strong>제2 조(이용약관의 효력 및 변경)</strong>
                    <ul>
                        <li>① 본 약관은 서비스 이용을 신청한 이용자(이하 “가입신청자”)가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로 등록함으로써 효력이 발생합니다.</li>
                        <li>② 가입신청자가 본 약관에 동의하였을 경우 본 약관의 내용을 모두 인지하였으며 서비스와 관련하여 본 약관에 따라 회사에서 제공하는 모든 서비스에 동의한 것으로 봅니다.</li>
                        <li>③ 회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
                        <li>④ 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 적용일자 최소 7일 전부터 공지하고, 개정 내용이 이용자에게 불리한 경우에는 그 적용일자 30일 전부터 서비스 홈페이지에 게시하거나 이용자에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여 고지합니다.</li>
                        <li>⑤ 이용자가 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 이용약관에 승인한 것으로 봅니다. 이용자가 개정약관에 동의하지 않을 경우 이용자는 이용계약을 해지할 수 있습니다.</li>
                    </ul>
                </div>    
                <div>
                    <strong>제3 조(관계법령의 적용)</strong>
                    <p>본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 및 회사가 정한 지침 또는 상관례에 따릅니다.</p>
                </div>
                <div>
                    <strong>제4 조(서비스의 내용)</strong>
                    <p>회사가 제공하는 위치기반서비스는 아래와 같습니다.</p>
                    <table>
                        <tr>
                            <th>서비스 명</th>
                            <th>서비스 내용</th>
                        </tr>
                        <tr>
                            <td>휴대폰가족보호</td>
                            <td>이용자의 휴대폰 및 서비스 이용 상태를 통해 위급 상황과 신체활동 상태 등을 판단하여 보호자에게 알리고 단계별로 대처할 수 있는 안심서비스<br>(*위치정보: 이용자의 위치를 보호자에게 알림)</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <strong>제5 조(서비스 이용)</strong>
                    <ul>
                        <li>① 본 서비스는 협약기관(이하 “대전광역시 유성구청”)과의 협약에 따라 이용자에게 무상으로 제공됩니다.</li>
                        <li>② 서비스 이용 기간은 서비스 이용신청을 회사가 승낙한 날로부터 10개월이며, 별도의 해지 신청 없이 자동 종료됩니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제6 조(서비스내용변경 통지 등)</strong>
                    <ul>
                        <li>① 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 이용자의 휴대전화 메시지 또는 기타 전자적 형태를 통하여 서비스 내용의 변경 사항 또는 종료를 통지할 수 있습니다.</li>
                        <li>② ①항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 웹사이트 등 기타 회사의 공지사항을 통하여 이용자들에게 통지할 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제7 조(서비스 이용의 제한 및 중지)</strong>
                    <ul>
                        <li>① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 이용자의 서비스 이용을 제한하거나 중지시킬 수 있습니다.
                            <ul>
                                <li>1. 이용자가 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우</li>
                                <li>2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우</li>
                                <li>3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우</li>
                                <li>4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때</li>
                                <li>5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우</li>
                            </ul>
                        </li>
                        <li>② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 이용자에게 알려야 합니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제8 조(개인위치정보의 이용 또는 제공)</strong>
                    <ul>
                        <li>① 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.</li>
                        <li>② 회사는 이용자의 동의 없이 개인위치정보를 제3자에게 제공하지 않으며, 제3자에게 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 이용자에게 고지하고 동의를 받습니다.</li>
                        <li>③ 회사는 타사업자 또는 이용자와의 요금정산 및 민원처리를 위해 위치정보 이용·제공 사실 확인자료를 자동 기록·보존하며, 해당 자료는 6개월간 보관합니다.</li>
                        <li>④ 회사는 이용자의 위급상황 발생 및 예방을 위한 목적으로 위치정보를 수집하며, 이용자가 지정한 보호자의 요청 시에만 조회하고 해당 정보를 별도 보유하지 않습니다.</li>
                        <li>⑤ 회사는 개인위치정보를 이용자가 지정하는 제3자에게 최초로 제공한 날부터 30일이 될 때마다 제공받는 자, 제공 일시, 목적 및 제공 횟수를 개인위치정보를 수집한 통신 단말장치로 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 이용자가 미리 특정하여 지정한 통신 단말장치 또는 전자우편주소로 통보합니다. 단 서비스 내 ‘보호자’로 지정한 경우 서비스 이용 시 연결상태를 표시하여 정보 제공여부를 통보합니다.
                            <ul>
                                <li>1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                                <li>2. 이용자가 온라인 게시 등의 방법으로 통보할 것을 미리 요청한 경우</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div>
                    <strong>제9 조(개인위치정보주체의 권리)</strong>
                    <ul>
                        <li>① 이용자는 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.</li>
                        <li>② 이용자는 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고 이를 위한 기술적 수단을 갖추고 있습니다.</li>
                        <li>③ 이용자는 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.
                            <ul>
                                <li>1. 이용자에 대한 위치정보 수집, 이용, 제공사실 확인자료</li>
                                <li>2. 이용자의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용</li>
                            </ul>
                        </li>
                        <li>④ 이용자는 제1항 내지 제3항의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제10 조(법정대리인의 권리)</strong>
                    <ul>
                        <li>① 회사는 14세 미만의 이용자에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해 이용자와 당해 이용자의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 이용자의 권리를 모두 가집니다.</li>
                        <li>② 회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용 및 제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공하고자 하는 경우에는 14세 미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.
                            <ul>
                                <li>1. 위치정보 및 위치기반서비스 제공에 따른 위치정보 이용, 제공사실 확인자료가 필요한 경우</li>    
                                <li>2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div>
                    <strong>제11 조(8세 이하의 아동 등의 보호의무자의 권리)</strong>
                    <ul>
                        <li>① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동” 등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
                            <ul>
                                <li>1. 8세 이하의 아동</li>
                                <li>2. 금치산자</li>
                                <li>3. 장애인복지법 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제29조의 규정에 의하여 장애인등록을 한 자에 한한다)</li>
                            </ul> 
                        </li>
                        <li>② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.</li>
                        <li>③ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제12 조(위치정보관리책임자의 지정)</strong>
                    <ul>
                        <li>① 회사는 위치정보를 적절히 관리 및 보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다.</li>
                        <li>② 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제13 조(위치정보 침해사고 등이 발생한 경우의 대응방법 및 절차)</strong>
                        <ul>
                            <li>① 회사는 위치정보 침해사고 발생 시 신속한 대응을 통한 피해 발생을 최소화하기 위해 다음과 같은 절차를 마련하고 있습니다.
                                <ul>
                                    <li>1. 위치정보 유출사실을 CEO에게 신속하게 보고하고 새로운 상황이 발생될 때마다 수시로 대응하기 위한 「위치정보유출신속대응팀」을 운영합니다.</li>
                                    <li>2. 위치정보 유출 원인을 파악한 후, 피해 최소화 등을 위해 취약점 제거 등 유출 원인을 제거하는 긴급 대응 조치를 실시하도록 합니다.</li>
                                    <li>3. 위치정보 주체에게 유출 사실을 통지하고 개인정보보호위원회 또는 한국인터넷진흥원에 유출 사실을 신고합니다.</li>
                                    <li>4. 위치정보의 유출로 인한 정보주체 피해구제 등 지원 방안을 마련하고 유사 사고의 재발방지를 위해 대책을 수립·시행합니다.</li>
                              </ul>
                            </li>
                        </ul>
                </div>
                <div>
                    <strong>제14 조(위치정보 주체의 요구 및 이의·불만 대응에 관한 사항)</strong>
                    <ul>
                        <li>① 위치정보사업자 등에 대한 열람 또는 고지 요구
                            <ul>
                                <li>1. 개인위치정보주체의 인적사항(다만, 대리인에 의하여 대리 청구하는 경우에는 대리인과의 관계 및 대리권의 표시를 포함)</li>
                                <li>2. 열람·고지를 요구한다는 의사</li>
                                <li>3. 열람·고지를 요구하는 내역</li>
                            </ul>
                        </li>
                        <li>② 본인 및 대리인의 확인<br/>위치정보 사업자 등은 열람·고지의 요구를 받은 때에는 요구자가 당해 개인위치정보주체(공인인증서, 핸드폰 인증 등을 통한 신분증명) 또는 정당한 대리인(위임장 등)임을 확인하여야 함</li>
                        <li>③ 개인위치정보주체에 대한 열람·고지의 결정 및 통지<br/>열람의 허용여부를 즉시 알려야 하며 열람·고지를 허용하지 않는 경우에는 그 사유와 근거를 설명하여야 함</li>
                        <li>④ 열람·고지의 실시<br/>위치정보 사업자 등은 열람·고지를 실시함에 있어서 제3자의 개인위치정보 및 여타 개인정보가 누설되지 아니하도록 필요한 조치를 취하여야 함</li>
                    </ul>
                </div>
                <div>
                    <strong>제15 조(위치정보취급자의 정기적인 교육에 관한 사항)</strong>
                    <p>회사는 개인위치정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하고 있으며, 위치정보취급자에게 위치정보보호에 대한 인식을 제고시키고 관련규정 및 법규 등을 준수하도록 주기적인 교육을 실시하고 있습니다.</p>
                </div>
                <div>
                    <strong>제16 조(손해배상)</strong>
                    <ul>
                        <li>① 회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 이용자에게 손해가 발생한 경우 이용자는 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.</li>
                        <li>② 이용자가 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 이용자에 대하여 손해배상을 청구할 수 있습니다. 이 경우 이용자는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제17 조(면책)</strong>
                    <ul>
                        <li>① 회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 이용자에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.
                            <ul>
                                <li>천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우</li>
                                <li>서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우</li>
                                <li>이용자의 귀책사유로 서비스 이용에 장애가 있는 경우</li>
                                <li>제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로 인한 경우</li>
                            </ul>
                        </li>
                        <li>② 회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 이용자의 손해에 대하여는 책임을 부담하지 아니합니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제18 조(규정의 준용)</strong>
                    <ul>
                        <li>① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.</li>
                        <li>② 본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.</li>
                    </ul>       
                </div>
                <div>
                    <strong>제19 조(분쟁의 조정 및 기타)</strong>     
                    <ul>
                        <li>① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에 관한 법률 제28조의 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.</li>
                        <li>② 회사 또는 이용자는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법 제43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.</li>
                    </ul>
                </div>
                <div>
                    <strong>제20 조(회사의 연락처)</strong>
                    <p>회사의 상호 및 주소 등은 다음과 같습니다.</p>
                    <ul>
                        <li>1. 상 호: 데이터유니버스</li>
                        <li>2. 대 표 자: 강원석</li>
                        <li>3. 주 소: 서울특별시 영등포구 국제금융로2길32, 7층 (여의도동, 여의도파이낸스타워)</li>
                        <li>4. 대표전화: 02-6013-0625</li>
                  </ul>
                </div>
                <div>
                    <strong>부 칙</strong>
                    <p>제1조(시행일)&nbsp;<span>본 약관은 2025년 03월 25일부터 시행합니다.</span></p>
                    <p>제2조&nbsp;<span>위치정보관리책임자는 2025년 3월을 기준으로 다음과 같이 지정합니다.</span></p>
                    <ul>
                        <li>1. 성명: 개발팀 이기호 팀장</li>
                        <li>2. 대표전화: 1855-3631</li>
                    </ul>
                </div>
            </section>`
    }
]

export default termsData;